import { object, string } from "yup";

export const generalSettingsSchema = object({
    advanceDirectSubsBank: string()
        .when("advanceDirectSubs", {
            is: true,  
            then: string()
                .required("Peşin Yönlendirme için Ödeme Altyapısı seçimi zorunludur.")
                .notOneOf(["0"], "Geçerli bir ödeme altyapısı seçiniz.")
        })
});